import Services from './base-services'
import global from '@/constants/GlobalConstant'
import mapParameters from '../utils/map-parameters'

const service = new Services('book')

export default {
    getAllPayBooks(number: number, size?: number) {
        const params = mapParameters({
            number: number ? number : 0,
            size: size ? size : 15
        })
        return service.get('getAllPayBooks', params)
    },
    getAllPayBookByUser(userId: number|string, number: number, size?: number) {
      const params = mapParameters({
          userId: userId ? userId : null,
          number: number ? number : 0,
          size: size ? size : 15
      })
      return service.get('getAllPayBookByUser', params)
  },
    getAllPayBooksByUser(userId: number|string, number: number, size?: number) {
        const params = mapParameters({
            userId: userId ? userId : null,
            number: number ? number : 0,
            size: size ? size : 15
        })
        return service.get('getAllPayBooksByUser', params)
    },
    getTopRatingPage(id: any) {
        return service.get(`getTopRatingPage?userId=${id}&number=0&size=10`)
    },
    getBookListFavoriteByUser(id: any) {
        return service.post(`getBookListFavoriteByUser?userId=${id}`)
    },
    getMostRequestedBooksPage(id: any) {
        return service.get(`getMostRequestedBooksPage?userId=${id}&number=0&size=10`)
    },
    getNewBooksPage(id: any) {
        return service.get(`getNewBooksPage?userId=${id}&number=0&size=10`)
    },
    getCompiledListOfUser(id: any) {
        return service.post(`getCompiledListOfUser?userId=${id}`)
    },
    getBookListByUser(id: any) {
        return service.post(`getBookListByUser?userId=${id}`)
    },
    getBookListByGrade(id: any) {
        return service.get(`getBookListByGrade?grade=${id}`)
    },
    getBookListSuggestedForUser(id: any) {
        return service.post(`getBookListSuggestedForUser?userId=${id}`)
    },
    getBookListByTittle(data: any) {
        return service.get(
            `getBookListByTittle?tittle=${data.title}&number=${data.number}&size=${data.size}`
        )
    },
    getBookListByTitle(title: any) {
        return service.get(`getBookListByTitle?tittle=${title}`)
    },
    // TODO Mejorar
    getChapterContentHTML(url: string) {
        return fetch(url)
    },
    getBookSummaryInfo(bookId: number, userId: number, assignmentType: 'SCHOOL' | 'MYSELF') {
        return service.get(`getBookSummaryInfo?bookId=${bookId}&userId=${userId}&assignmentType=${assignmentType}`)
    },
    getEPUBBookContent(resourceDir: any) {
        return fetch(`${global.BASE_URL_BOOK}${resourceDir}/OEBPS/content.opf`)
    },
    getEPUBBookPage(resourceDir: any, epubPageTarget: any) {
        return fetch(`${global.BASE_URL_BOOK}${resourceDir}/OEBPS/${epubPageTarget}`)
    },
}
